import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { comOrder } from '../../actions/orderActions';
import v from '../../styles/img/arrow/v.svg';

import Ratingstar from '../Rating_star';

const RatingCard = ({ store }) => {
  const { loading, success } = useSelector((state) => state.orderCom);
  const [isContentVisible, setisContentVisible] = useState(false);

  return (
    <>
      {loading || !store ? (
        <>
          <div></div>
        </>
      ) : (
        <div className="w-full flex justify-center tremble">
          <div
            onClick={() => {
              window.open(store?.avis_google, '_blank');
              setisContentVisible(!isContentVisible);
            }}
            className={`recus py-4 bg-[#EAF4B0] flex flex-col justify-start items-center  w-[90%] py-2 ] transition-all duration-300 px-4 rounded-[8px]   overflow-hidden`}
          >
            <div className="flex w-full justify-between items-center px-4">
              <div className="flex flex-col w-full items-center ">
                <span
                  className="font-light text-[20px] text-center"
                  style={{ fontFamily: 'geomanistmedium' }}
                >
                  Comment s’est passé ton achat sur Pikko ?
                </span>
              </div>
            </div>
            <div
              id=""
              style={{ fontFamily: 'Open Sans' }}
              className={`transition-all w-full duration-700 text-[16px] flex items-center justify-center rounded-[10px]  px-4  w-full flex-wrap `}
            >
              <div className="flex flex-col justify-center items-center w-full rounded-[3em]  gap-6">
                <a
                  className="w-full"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Ratingstar />

                  {/* <div className="flex text-4xl gap-1 items-center justify-between rounded-[13px] w-full ">

            <div className=" payer w-full rounded-[1em] self-stretch flex items-center">

              <img
                src="https://firebasestorage.googleapis.com/v0/b/pikkopay.appspot.com/o/Webapp%2ForderSuccess%2Frating_google_logo.png?alt=media&token=5494e51b-6a99-4e00-9fcd-a45a39d7e207"
                className="w-20 h-auto p-4"
              ></img>
              <p className="geomanistBold text-[1.7rem]  pr-4" style={{fontFamily: 'poppinsmedium'}}>
                Laisser un avis Google
              </p>
            </div>
          </div>
        */}
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RatingCard;
